<template>
  <form @submit.prevent="createController">
    <DxForm :form-data="newController"  label-location="left" :min-col-width="350">
      <DxGroupItem :col-count="1" :min-col-width="330">
        <DxSimpleItem data-field="name" :is-required="true" >
          <DxCustomRule :validation-callback="NameValidation"
                message="Name is already registered" />
        </DxSimpleItem>
        <DxSimpleItem 
          data-field="description" 
          editor-type="dxTextBox"
          :editor-options="{ maxLength: 300 }" 
        />
        <DxSimpleItem 
          data-field="compType" 
          editor-type="dxSelectBox"
          :editor-options="{ dataSource: controllerList, valueExpr:'id', displayExpr:'label'}" 
        />

        <DxSimpleItem data-field="isEnabled" editor-type="dxCheckBox" />  
      </DxGroupItem>
      <DxGroupItem :col-count="2" :min-col-width="160">
        <DxButtonItem :button-options="{ type:'danger', width: '100%', text: 'Cancel', useSubmitBehavior: false, onClick: cancelCreation }" />
        <DxButtonItem :button-options="{ type:'success', width: '100%', text: 'Create Controller', useSubmitBehavior: true }" />
      </DxGroupItem>
      
    </DxForm>
  </form>
</template>

<script>
import DxForm, {
  DxGroupItem,
  DxButtonItem,
  DxSimpleItem,
} from 'devextreme-vue/form';
import {
  DxCustomRule,
} from 'devextreme-vue/validator';
import notify from 'devextreme/ui/notify';
import { ref } from 'vue';
import RawDataService from '../services/RawDataServiceTemplate';
import controllerParamSchemes from '../utils/controller-params-schema.json'
export default {
  components: {
    DxForm,
    DxGroupItem,
    DxButtonItem,
    DxSimpleItem,
    DxCustomRule,
  },
  props: {
    controllerNames: [],
    controllerList:[]
  },
  emits: ['controller-update', 'cancel'],
  setup(props,{ emit }) {
    const newController = ref({
      name: null,
      description: null,
      isEnabled: false,
      compType:null
    });
    
    const controllerDataService = new RawDataService('controllers');


    const clearControllerObj = () => {
      newController.value.name=null;
      newController.value.description=null;
      newController.value.isEnabled=false;
      newController.value.compType=null
    };

    const NameValidation = (params)=>{
      const param = props.controllerNames.find(e=>e.id==params.value);
      return !param
    }

    const createController = async () => {
      try{
        const res = await controllerDataService.create(newController.value);
        if(res.isOk){
          const paramsControllerService =  new RawDataService('controllers/'+ res.insertId +'/params');
          const comptype = props.controllerList.find(c=>c.id==newController.value.compType).ctrl
          await paramsControllerService.create({
            controllerId: res.insertId,
            paramName: 'static',
            paramSchema: JSON.stringify({type:'object', //TODO: save schemas in other file
                            properties:{
                            }}),
            value: JSON.stringify(controllerParamSchemes[comptype]),
            description: null,
          })
        
          notify(res.message||'controller creation sent', "success", 4000);
          emit('controller-update', {  
            objectType: 'controller', 
            key: newController.value.name, 
            type:'insert',
            message: res.message||'controller creation sent',
            data: {
              id: res.insertId,
              name: newController.value.name,
              description: newController.value.description,
              isEnabled: newController.value.isEnabled,
              compType:newController.value.compType,
            }
          });
          
          clearControllerObj();
        }
        
      }catch(error){
        emit('cancel', { reason: error.message||'error creating controller' });
      }
    }
    const cancelCreation = () => {
      clearControllerObj();
      emit('cancel', { reason: 'action cancelled by user'});
    }
    
    return {
      newController,
      NameValidation,
      createController,
      cancelCreation,
    }
  }
}
</script>

<style>

</style>